import React from 'react'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import Data from 'EurestoClass/Data'
import Datagrid from '../../../../CRM/Component/Table/index'
import Grid from '@material-ui/core/Grid'

class Search extends React.Component {

  constructor (props) {
    super(props)
    const data = Data.list(Constants.module.CONFIGURATION, Constants.donnee.etablissement, {})
    this.state = {
      data: data
    }
  }

  async componentDidMount () {
    await Promise.all(this.state.data.map(async (d, i) => {
      this.state.data[i].token = await User.Connect.go(d.key_contact)
    }))
  }

  async update (row) {
    if (row.token !== undefined) {
      window.open('/?token=' + row.token, '_blank')
    }
  }

  render () {
    return (
      <Grid container spacing={0} style={{ margin: 0, padding: 0 }} justify={'center'}>
        <Grid item md={6} xs={12} xl={3} lg={4}>
          <Datagrid onClick={this.update}
                    view={'list'}
                    data={this.state.data}
                    type="etablissement"/>
        </Grid>
      </Grid>)
  }
}

export default Search





// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Etablissement/EtablissementsGroupe/index.js